//
// Copyright 2023 DXOS.org
//

import { type Resource } from '@dxos/react-ui';

export const translationKey = '@dxos/react-ui-menu';

export const translations = [
  {
    'en-US': {
      [translationKey]: {
        'toolbar-overflow.menu': 'More',
      },
    },
  },
] as const satisfies Resource[];
